import { Link } from "@onclicks/sharedmobilei18n/routing";
import { Media } from "../Media/Media";
import { Media as MediaType } from "@/payload-types";

export const Logo = ({
  logo,
  className,
}: {
  logo: number | MediaType | null | undefined;
  className?: string;
}) => {
  return (
    <Link href="/" className={className}>
      <Media resource={logo} imgClassName="w-48 shrink-0" />
    </Link>
  );
};
